import React from "react";
import PropTypes from "prop-types";
import styles from "./AirlineDropdown.module.css";

const AirlineDropdown = ({
  airlines,
  value,
  onChange,
  onBlur,
  error,
  errorMessage,
}) => {
  const handleChange = (event) => {
    onChange(event);
  };

  return (
    <>
      <select
        className={`form-select ${error ? styles.isInvalid : ""}`}
        id={styles.select}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
      >
        {airlines.map((airline, index) => (
          <option key={index} value={airline.label} disabled={index === 0}>
            {airline.label}
          </option>
        ))}
      </select>
      {error && <div className={styles.errorText}>{errorMessage}</div>}
    </>
  );
};

AirlineDropdown.propTypes = {
  airlines: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
};

export default AirlineDropdown;
